import type { ReactNode } from 'react'
import { View } from 'react-native'

import { Message } from '@/src/elements/message'
import { ICON } from '@/src/general/enums/icons'
import { useTranslate } from '@/src/lang/useTranslate'

import { useUnblockConversationMutation } from '../../services/useUnlockConversationMutation'

type TBlockedConversationMessageProps = { conversationId: number }

export const BlockedConversationMessage = ({ conversationId }: TBlockedConversationMessageProps): ReactNode => {
  const { t } = useTranslate()
  const { mutate, isPending } = useUnblockConversationMutation(conversationId)

  return (
    <View className="items-center p-4">
      <Message
        colors="danger"
        iconName={ICON.SLASH_CIRCLE}
        buttons={[{ children: t('conversation.unblock'), onPress: () => mutate(), isLoading: isPending }]}
        className="max-w-lg max-w-full"
      >
        {t('conversation.you-blocked')}
      </Message>
    </View>
  )
}
